import { render } from "./InsightDisplayArea.vue?vue&type=template&id=6076c096&scoped=true"
import script from "./InsightDisplayArea.vue?vue&type=script&lang=js"
export * from "./InsightDisplayArea.vue?vue&type=script&lang=js"

import "./InsightDisplayArea.vue?vue&type=style&index=0&id=6076c096&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6076c096"]])

export default __exports__